import Vue from 'vue'
import LocationPlugin from './locationPlugin'
import AnalyticsPlugin from './analyticsPlugin'
import ConfigPlugin from './configPlugin'

Vue.use(LocationPlugin)
Vue.use(AnalyticsPlugin)
Vue.use(ConfigPlugin)
